import { Link, NavLink } from "react-router-dom";
import { Phone, Menu, X } from "lucide-react";
import { useState } from "react";
import { Button } from "../components/ui/button";
import { BRAND } from "../lib/brand";

const navItems = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About Us" },
  { to: "/services", label: "Services" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 w-full border-b border-border bg-white/85 backdrop-blur-md"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-20">
        <Link
          to="/"
          data-testid="header-logo-link"
          className="flex items-center gap-3 group"
          onClick={() => setOpen(false)}
        >
          <img
            src={BRAND.logoUrl}
            alt="E L Lawn Services Inc Logo"
            className="h-12 w-12 object-contain"
          />
          <div className="hidden sm:flex flex-col leading-tight">
            <span className="font-display text-base font-bold tracking-tight text-gray-900">
              E L Lawn Services Inc
            </span>
            <span className="text-xs text-gray-500 font-body">
              Trusted in South Florida for {BRAND.experienceYears}+ years
            </span>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8" data-testid="desktop-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              data-testid={`nav-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `font-body text-sm font-medium transition-colors hover:text-[#15803D] ${
                  isActive ? "text-[#15803D]" : "text-gray-700"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={`tel:${BRAND.phoneTel}`}
            data-testid="header-call-link"
            className="flex items-center gap-2 text-sm font-medium text-gray-700 hover:text-[#15803D]"
          >
            <Phone className="h-4 w-4" />
            {BRAND.phone}
          </a>
          <Button
            asChild
            data-testid="header-quote-button"
            className="bg-[#DC2626] hover:bg-red-700 text-white rounded-full px-5"
          >
            <Link to="/contact">Get Free Quote</Link>
          </Button>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          aria-label="Toggle navigation"
          className="lg:hidden p-2 text-gray-700"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden border-t border-border bg-white"
        >
          <div className="px-4 py-4 flex flex-col gap-3">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `font-body text-base py-2 ${
                    isActive ? "text-[#15803D] font-semibold" : "text-gray-700"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <a
              href={`tel:${BRAND.phoneTel}`}
              data-testid="mobile-call-link"
              className="flex items-center gap-2 text-sm text-gray-700 py-2"
            >
              <Phone className="h-4 w-4" /> {BRAND.phone}
            </a>
            <Button
              asChild
              data-testid="mobile-quote-button"
              className="bg-[#DC2626] hover:bg-red-700 text-white w-full rounded-full"
            >
              <Link to="/contact" onClick={() => setOpen(false)}>
                Get Free Quote
              </Link>
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
